import Vue from 'vue';
import VueRouter from 'vue-router';
import VueResource from 'vue-resource'
import App from './App.vue';
import { routes } from './routes';
import store from './store/store';
import { sync } from 'vuex-router-sync'
import globalMixin from './lib/globalMixin';
import $ from 'jquery';

Vue.use(VueRouter);
Vue.use(VueResource);
Vue.mixin(globalMixin);

if (process.env.NODE_ENV === "production") {
  Vue.http.options.root = 'https://app-api.abceed.com/';
} else {
  Vue.http.options.root = 'https://app-api.abceed.com/';
  // Vue.http.options.root = 'https://2zw3cqudp7.execute-api.ap-northeast-1.amazonaws.com/dev/';
}
Vue.http.headers.common['Content-Type'] = "application/json";
Vue.http.interceptors.push(function (request, next) {
  const sessionToken = window.localStorage.getItem(['sessionToken']);
  if (sessionToken) {
    request.headers.set('Authorization', `Bearer ${sessionToken}`);
  }

  return function (response) {
    if (response.status === 401) {
      window.localStorage.clear();
      store.dispatch('hideLightBox');
      store.dispatch('resetAllStore');
    } else {
      next();
    }
  };
});

// filter
import filter from './filter';
filter(Vue);

//ルーティング(ログイン判定)処理
const router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior(to, from, savedPosition) {
    if ((to.name === 'rankingHome' || to.name === 'categoryDetail') && from.name === 'bookDetail') {
      if (savedPosition && savedPosition.y !== 0) {
        if (to.name === 'categoryDetail') {
          setTimeout(() => {
            $('#app').css('height', 10000);
            $('body, html').animate({ scrollTop: savedPosition.y }, 6);
            $('#app').css('height', 'auto');
          }, 400);
        } else {
          $('#app').css('height', 10000);
          $('body, html').animate({ scrollTop: savedPosition.y }, 6);
        }
      }
    }
  }
});
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.isLoginPage) && window.localStorage.getItem(['sessionToken'])) {
    next({ path: '/' })
  } else {
    if (to.matched.some(record => record.meta.requiresAuth) && !window.localStorage.getItem(['sessionToken'])) {
      if (to && to.name) {
        if (to.name === 'paymentWay') {
          next({ path: '/login?from=' + from.path })
        } else {
          next({ path: '/login?from=' + to.path })
        }
      } else {
        next({ path: '/login' })
      }
    } else {
      next()
    }
  }
});

sync(store, router);

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js